var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUserBot(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29.178,
    height: 29.179,
    viewBox: "0 0 33.178 33.179",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "user",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12221",
    "data-name": "Path 12221",
    d: "M15.181,29l-4.95,2.7a4.448,4.448,0,0,0-.794.565,16.579,16.579,0,0,0,21.3.055,4.391,4.391,0,0,0-.873-.585l-5.3-2.65a2.021,2.021,0,0,1-1.117-1.808V25.2a8.005,8.005,0,0,0,.5-.645,12.2,12.2,0,0,0,1.648-3.32,1.665,1.665,0,0,0,1.181-1.584v-2.22a1.657,1.657,0,0,0-.555-1.23V12.995S26.883,8,20.12,8s-6.1,4.994-6.1,4.994V16.2a1.655,1.655,0,0,0-.555,1.23v2.22a1.664,1.664,0,0,0,.768,1.4A11.016,11.016,0,0,0,16.236,25.2v2.028A2.023,2.023,0,0,1,15.181,29Z",
    transform: "translate(-3.529 -2.992)",
    fill: "#e7eced"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1134",
    "data-name": "Group 1134",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12222",
    "data-name": "Path 12222",
    d: "M16.873,0A16.579,16.579,0,0,0,5.915,29.273a4.408,4.408,0,0,1,.787-.56l4.95-2.7a2.022,2.022,0,0,0,1.054-1.775V22.21A11.006,11.006,0,0,1,10.7,18.058a1.665,1.665,0,0,1-.768-1.4v-2.22a1.657,1.657,0,0,1,.555-1.23V10s-.659-4.994,6.1-4.994S22.693,10,22.693,10v3.209a1.655,1.655,0,0,1,.555,1.23v2.22a1.665,1.665,0,0,1-1.181,1.584,12.2,12.2,0,0,1-1.648,3.32,8.005,8.005,0,0,1-.5.645v2.08A2.021,2.021,0,0,0,21.035,26.1l5.3,2.65a4.414,4.414,0,0,1,.87.583A16.586,16.586,0,0,0,16.873,0Z",
    transform: "translate(0 0)",
    fill: "#62b5b4"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserBot);
export default __webpack_public_path__ + "static/media/userBot.516efc3b8b1895d60f8d74710c44e002.svg";
export { ForwardRef as ReactComponent };